import React, { FunctionComponent } from 'react';

import FaqPanel from '@/components/landingPages/FaqPanel';
import Row from '@/components/layout/Row';
import Col from '@/components/layout/Col';
import LandingPageContentSection from '@/components/landingPages/LandingPageContentSection';
import PrismicContentSectionRenderer from '@/components/landingPages/PrismicContentSectionRenderer';

import { IPrismicContentElement, IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';

interface IOneFaqItemProps {
  title: string;
  text: IPrismicRichTextElement[];
}

const OneFaqItem: FunctionComponent<IOneFaqItemProps> = ({ title, text }) => (
  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
    <FaqPanel questionText={title} answerText={text} panelKey={`faq-${1}`} />
  </Col>
);

interface IProps {
  contentTop: IPrismicContentElement[];
}

const FaqPageComponent: FunctionComponent<IProps> = ({ contentTop }) => (
  <div style={{ marginTop: 30, minHeight: 400 }}>
    <LandingPageContentSection>
      <Row gutter={[30, 15]}>
        <PrismicContentSectionRenderer content={contentTop} Component={OneFaqItem} />
      </Row>
    </LandingPageContentSection>
  </div>
);

export default FaqPageComponent;
